import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Home from '../pages/home.jsx';
import ProductDetails from '../components/products/ProductDetails.jsx';
import Wishlist from '../pages/user/wishlist';
import Login from '../pages/login';
import Signup from '../pages/signup';
import Terms from '../pages/terms';
import Privacy from '../pages/privacy';
import Contact from '../pages/contactpage.jsx';
import MyAccount from '../pages/user/account';
import Cart from '../pages/user/cart.jsx';
import Admin from '../pages/admin/dashboard.jsx';
import Checkout from '../pages/product/Checkout.jsx';
import CheckoutSuccess from '../pages/product/checkoutSuccess.jsx';
import OrderPlaceSuccess from '../pages/product/orderPlaceSuccess.jsx';
import ProtectedRoute from './protectedRoutes.js';
import ViewAll from '../pages/product/ViewAll.jsx';
import Category from '../pages/product/categories.jsx';
import Related from '../components/products/Releted.jsx';
import EmailVerify from '../components/Email/emailVerify.jsx';
import SearchResults from '../components/products/searchProducts.jsx';

function App({ searchTerm }) {
  return (
    <Routes>
      <Route
        path='/'
        element={<Home searchTerm={searchTerm} />}
      />
      <Route
        path='/terms'
        element={<Terms />}
      />
      <Route
        path='/privacy'
        element={<Privacy />}
      />
      <Route
        path='/products/:id'
        element={<ProductDetails />}
      />
      <Route
        path='/wishlist'
        element={<Wishlist />}
      />
      <Route
        path='/sign-up'
        element={<Signup />}
      />
      <Route
        path='/login'
        element={<Login />}
      />
      <Route
        path='/contact'
        element={<Contact />}
      />
      <Route
        path='/cart'
        element={<Cart />}
      />
      <Route
        path='/checkout'
        element={<Checkout />}
      />
      <Route
        path='/checkout-success'
        element={<CheckoutSuccess />}
      />
      <Route
        path='/order-place-success'
        element={<OrderPlaceSuccess />}
      />
      <Route
        path='/view-all'
        element={<ViewAll />}
      />
      <Route
        path='/category'
        element={<Category />}
      />
      <Route
        path='/related/:id'
        element={<Related />}
      />
      <Route
        path='/auth/:id/verify/:token'
        element={<EmailVerify />}
      />
      <Route
        path='/search'
        element={<SearchResults />}
      />

      {/* ---------Protected Routes--------- */}
      <Route
        path='/admin'
        element={
          <ProtectedRoute allowRoles={['admin']}>
            <Admin />
          </ProtectedRoute>
        }
      />
      <Route
        path='/my-account'
        element={
          <ProtectedRoute allowRoles={['customer']}>
            <MyAccount />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

export default App;
